module.exports = __webpack_public_path__ + "static/media/poster-beaches.d963b17e.jpg";